export default "__VITE_ASSET__v2wHePKs__"